import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { Box, Typography, Grid, Divider, Button, Avatar } from "@mui/material";
import { GeneratePrevieUrl } from "../common/utils/generatePreviewUrl";
import { useApi } from "../store/UserLoginContext";
const moment = require("moment");

// const LabelValue = ({ label, width = "100%" }) => (
//   <Box sx={{ display: "flex", gap: 1, width, mb: 1.5 }}>
//     <Typography component="span" sx={{ minWidth: "200px", fontWeight: 600 }}>
//       {label}
//     </Typography>
//     <Typography
//       component="span"
//       sx={{ borderBottom: "1px solid #000", flex: 1 }}
//     >
//       &nbsp;
//     </Typography>
//   </Box>
// );

const LabelValue = ({ label, value = "", width = "100%" }) => (
  <Box sx={{ display: "flex", gap: 1, width, mb: 1 }}>
    <Typography component="span" sx={{ minWidth: "200px", fontWeight: 600 }}>
      {label}
    </Typography>
    <Typography
      component="span"
      sx={{ borderBottom: "1px solid #000", flex: 1 }}
    >
      {value || "\u00A0"}
    </Typography>
  </Box>
);

const SectionTitle = ({ children }) => (
  <Typography variant="h6" fontWeight="bold" sx={{ mt: 2, mb: 1 }}>
    {children}
  </Typography>
);

const NewForm = (props, currentSessionAY, ref) => {
  return (
    <Box
      ref={ref}
      sx={{
        width: "186mm",
        minHeight: "277mm",
        padding:"2mm",
        bgcolor: "#fff",
        color: "#000",
        fontSize: "13px", // slightly reduced
        lineHeight: 1.6,
        fontFamily: "serif",
      }}
    >
      <style>
        {`@media print {
        @page {
          size: A4 portrait;
          margin: 10mm;
        }
      }`}
      </style>

      {/* Header */}
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
        <Box width="100%" bgcolor="grey.100" p={1.5}>
          <Grid container alignItems="center" justifyContent="space-between">
            <Grid item>
              <img
                src="/img/vpm_gns_logo.png"
                width={70}
                height={50}
                alt="School Logo"
              />
            </Grid>
            <Grid item xs textAlign="center" mr={4}>
              <Typography sx={{ fontFamily: "Alien Invader", fontSize: 30 }}>
                V.P.M Gyan Niketan School
              </Typography>
              <Typography>
                A sr.secondary (10+2) school, Affiliated to C.B.S.E, Delhi
              </Typography>
              <Typography variant="caption">
                Affiliation no. 3430175, School Code - 66373, U-Dise no.
                20020102742
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Box>

      <Typography align="center" fontWeight="bold">
        {`ADMISSION FORM ${currentSessionAY}`}
      </Typography>
      <Divider sx={{ my: 1 }} />

      {/* Personal Details */}
      <SectionTitle>Personal Details</SectionTitle>
      <Grid container spacing={4}>
        <Grid item xs={9}>
          <Grid container spacing={0.5}>
            <Grid item xs={12}>
              <LabelValue
                label="Student Name:"
                value={props.personal_details.name}
              />
            </Grid>
            <Grid item xs={12}>
              <LabelValue
                label="Date of Birth:"
                value={moment(props.personal_details.dob, "YYYY-MM-DD").format(
                  "DD-MM-YYYY"
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <LabelValue
                label="Gender:"
                value={props.personal_details.gender.toUpperCase()}
              />
            </Grid>
            <Grid item xs={12}>
              <LabelValue label="Adhaar No:" value={props.adhaar} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={3}>
          <Box
            sx={{ border: "1px solid #000", width: 110, height: 110, ml: 1 }}
          >
            {props.photoUrl ? (
              <Avatar
                src={props.photoUrl}
                variant="square"
                sx={{ width: "100%", height: "100%" }}
              />
            ) : (
              <Box
                sx={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Typography variant="caption" align="center">
                  Student Photo
                </Typography>
              </Box>
            )}
          </Box>
        </Grid>
      </Grid>

      {/* Admission Info */}
      <SectionTitle>Admission Information</SectionTitle>
      <Grid container spacing={0.1}>
        {[
          [
            "Admission Date:",
            moment(props.admission_date, "YYYY-MM-DD").format("DD-MM-YYYY"),
          ],
          ["Class to which admission sought:", props.class_name],
          ["Admission ID:"],
          ["Apaar ID:", props.apaar],
          ["Pen ID:", props.pen],
          // ["Admission Scheme:", props.admission_scheme],
          ["Caste:", props.cast],
          ["Single Girl Child:", props.girl_single_child],
          ["Is Physically Disabled:", props.physically_disabled],
          ["Belong to EWS:", props.is_ews],
        ].map(([label, value], index) => (
          <Grid item xs={6} key={index}>
            <LabelValue label={label} value={value} />
          </Grid>
        ))}
        <Grid item xs={12}>
          <LabelValue
            label="Previous School:"
            value={props.previous_school.name}
          />
        </Grid>
        <Grid item xs={6}>
          <LabelValue
            label="Last Class Attended:"
            value={props.previous_school.last_class_attended}
          />
        </Grid>
      </Grid>

      {/* Residential Address */}
      <SectionTitle>Residential Address</SectionTitle>
      <Grid container spacing={0.5}>
        <Grid item xs={12}>
          <LabelValue
            label="Line 1:"
            value={props.personal_details.correspondence_address.addressline1}
          />
        </Grid>
        <Grid item xs={6}>
          <LabelValue
            label="Line 2:"
            value={props.personal_details.correspondence_address.addressline2}
          />
        </Grid>
        <Grid item xs={6}>
          <LabelValue
            label="City:"
            value={props.personal_details.correspondence_address.city}
          />
        </Grid>
        <Grid item xs={6}>
          <LabelValue
            label="State:"
            value={props.personal_details.correspondence_address.state}
          />
        </Grid>
        <Grid item xs={6}>
          <LabelValue
            label="Pin Code:"
            value={props.personal_details.correspondence_address.pincode}
          />
        </Grid>
      </Grid>

      {/* Permanent Address */}
      <SectionTitle>Permanent Address</SectionTitle>
      <Grid container spacing={0.5}>
        {["addressline1", "addressline2"].map((line, idx) => (
          <Grid item xs={12} key={idx}>
            <LabelValue
              label={`Line ${idx + 1}:`}
              value={props.personal_details.permanent_address[line]}
            />
          </Grid>
        ))}
        <Grid item xs={6}>
          <LabelValue
            label="City:"
            value={props.personal_details.permanent_address.city}
          />
        </Grid>
        <Grid item xs={6}>
          <LabelValue
            label="State:"
            value={props.personal_details.permanent_address.state}
          />
        </Grid>
        <Grid item xs={6}>
          <LabelValue
            label="Pin Code:"
            value={props.personal_details.permanent_address.pincode}
          />
        </Grid>
      </Grid>

      {/* Parent Details */}
      {[
        { title: "Father's Details", data: props.father_details },
        { title: "Mother's Details", data: props.mother_details },
        { title: "Guardian's Details", data: props.guardian_details },
      ].map(({ title, data }, idx) => (
        <Box key={idx}>
          <SectionTitle>{title}</SectionTitle>
          <Grid container spacing={0.5}>
            <Grid item xs={12}>
              <LabelValue label="Name:" value={data.name} />
            </Grid>
            <Grid item xs={6}>
              <LabelValue label="Education:" value={data.education} />
            </Grid>
            <Grid item xs={6}>
              <LabelValue label="Occupation:" value={data.occupation} />
            </Grid>
            <Grid item xs={6}>
              <LabelValue label="Phone:" value={data.contact} />
            </Grid>
            <Grid item xs={6}>
              <LabelValue label="Annual Income:" value={data.annual_income} />
            </Grid>
            <Grid item xs={12}>
              <LabelValue label="Adhaar:" value={data.adhaar} />
            </Grid>
            {/* {title.includes("Guardian") && (
              <Grid item xs={6}>
                <LabelValue label="Blood Relation:" value={data.relation} />
              </Grid>
            )} */}
          </Grid>
        </Box>
      ))}

      {/* Declaration */}
      <SectionTitle>Declaration</SectionTitle>
      <Typography fontSize="13px">
        "I hereby declare that the above information including name of the
        candidate, Father's/Mother's/Guardian's name and date of birth furnished
        by me is correct to the best of my knowledge & belief. I shall abide by
        the rules of the school."
      </Typography>

      <Grid container spacing={0.5} mt={1}>
        {[
          "Signature of Father:",
          "Signature of Mother:",
          "Signature of Guardian (if applicable):",
          "Relation with Candidate:",
          "Date:",
        ].map((label, i) => (
          <Grid item xs={6} key={i}>
            <LabelValue label={label} />
          </Grid>
        ))}
      </Grid>

      <Box sx={{ mt: 2 }}>
        <LabelValue label="Correct entries from the admission forms to the Admission & Withdrawal Register have been made on page no.:" />
        <LabelValue label="Dated:" />
        <LabelValue label="Signature of Principal:" />
      </Box>
    </Box>
  );
};

const AdmissionForm = React.forwardRef(({ feesData }, ref) => {
  const { currentSessionAY } = useApi();
  const data = feesData;
  console.log("Data Received as");
  console.log(data);
  if (!data) return;

  const getPhotoUrl = data.photoUrl ? GeneratePrevieUrl(data.photoUrl) : "";

  const updateData = {
    ...data,
    photoUrl: getPhotoUrl,
  };

  const jsxElementArray = NewForm(updateData, currentSessionAY, ref);
  return <div ref={ref}>{jsxElementArray}</div>;
});

export default AdmissionForm;

// export default function AdmissionFormPrint() {
//   const componentRef = useRef();
//   const handlePrint = useReactToPrint({
//     content: () => componentRef.current,
//   });

//   return (
//     <Box>
//       <Button variant="contained" onClick={handlePrint}>
//         Print Admission Form
//       </Button>
//       <Box sx={{ display: "none" }}>
//         <AdmissionForm ref={componentRef} />
//       </Box>
//     </Box>
//   );
// }
